import React, { useCallback } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Stack,
  Text,
  Button,
} from "@chakra-ui/react";
import { Reservation } from "../../types";
import dayjs from "dayjs";
import { isMobile } from "react-device-detect";
import { PrimayButton } from "../Button";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  reservation: Reservation;
  onCancel: (reservation: Reservation) => any;
  onReschedule: (reservation: Reservation) => any;
};

export const ReservationModal: React.FC<Props> = observer(
  ({ isOpen, onClose, reservation, onCancel, onReschedule }) => {
    const handlePartecipateClick = useCallback(() => {
      ReactGA.event({
        category: "Customer",
        action: reservation.eventMeta?.name || "Allenamento Diretta",
      });
      ReactPixel.track(reservation.eventMeta?.name || "Allenamento Diretta");

      window.open(reservation.eventMeta?.location?.join_url, "_blank");
    }, [reservation]);

    return (
      <Modal isOpen={isOpen} onClose={onClose} size={isMobile ? "xs" : "sm"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{"Prenotazione"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack>
              <Stack alignItems="center">
                <Text fontSize={"2xl"}>
                  {reservation.source === "calendly"
                    ? reservation.eventMeta?.name
                    : ""}
                </Text>

                <Text>
                  {reservation.source === "calendly"
                    ? "Data: " +
                      dayjs(reservation.eventMeta?.start_time).format(
                        "DD MMMM YY"
                      )
                    : ""}
                </Text>
                <Text>
                  {reservation.source === "calendly"
                    ? "Ore: " +
                      dayjs(reservation.eventMeta?.start_time).format("HH:mm")
                    : ""}
                </Text>

                <Text fontSize="sm" textAlign="center">
                  {reservation.source === "calendly"
                    ? "Potrai collegarti a partire da 5 minuti dall'inizio dell'evento"
                    : ""}
                </Text>
              </Stack>

              {reservation.source === "calendly" &&
                reservation.eventMeta?.location?.join_url && (
                  <PrimayButton
                    mx="5px"
                    disabled={
                      !(
                        dayjs().isAfter(
                          dayjs(reservation.eventMeta?.start_time).subtract(
                            5,
                            "minute"
                          )
                        ) &&
                        dayjs().isBefore(dayjs(reservation.eventMeta?.end_time))
                      )
                    }
                    onClick={handlePartecipateClick}
                  >
                    Partecipa su Zoom
                  </PrimayButton>
                )}
              {reservation.source === "calendly" && (
                <Button
                  colorScheme="red"
                  variant="ghost"
                  onClick={() => onCancel(reservation)}
                >
                  Cancella prenotazione
                </Button>
              )}

              {reservation.source === "calendly" &&
                reservation.eventMeta.reschedule_url && (
                  <Button
                    variant="ghost"
                    onClick={() => onReschedule(reservation)}
                  >
                    Riprogramma
                  </Button>
                )}
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  }
);
